import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/zhyq/banner.png';
import _imports_1 from '../assets/page-image/zhyq/content_new.jpg';
const _hoisted_1 = {
  class: "zhyq-wrapper"
};
import Footer from "@/components/Footer.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'Zhyq',
  setup(__props) {
    const goToPlatform = () => {
      window.open("http://101.201.181.31:9090/#/?breedId=2f66c540402211ef9fb698039b2bdf44", "_blank");
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "banner-section"
      }, [_createElementVNode("div", {
        class: "banner-line"
      }), _createElementVNode("div", {
        class: "banner-content"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "智慧园区"
      })])], -1)), _createElementVNode("div", {
        class: "content-section"
      }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "content-left"
      }, null, -1)), _createElementVNode("div", {
        class: "content-center"
      }, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_1,
        alt: "基于人工智能的双创服务平台"
      }, null, -1)), _createElementVNode("div", {
        class: "btn",
        onClick: goToPlatform
      }, "点击跳转")]), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "content-right"
      }, null, -1))]), _createVNode(Footer)]);
    };
  }
});